import React from "react";

import { FormControl, FormHelperText, TextField } from "@mui/material";

/** Manual Pinterest CAPI fields: ad account id, access token, tag id. */
const PinterestCapiFields = ({
    language,
    formData,
    onChange,
    accountIdError,
    accessTokenError,
}) => {
    const validationError =
        language?.source_modal?.validation_error ?? "Validation Error";
    const accountIdLabel =
        language?.destination_modal?.add_account_id ?? "Ad Account ID";
    const accessTokenLabel =
        language?.destination_modal?.access_token ?? "Access Token";
    const tagIdLabel =
        language?.destination_modal?.pinterest_tag_id ?? "Pinterest Tag ID";

    return (
        <div className="mb-3">
            <FormControl
                className="mb-3"
                style={{ width: "100%" }}
                error={Boolean(accountIdError)}
            >
                <TextField
                    name="accountId"
                    inputProps={{ "data-cy": "create-destination-account-id" }}
                    label={accountIdLabel}
                    variant="outlined"
                    onChange={onChange}
                    value={formData.accountId}
                    placeholder={accountIdLabel}
                    error={Boolean(accountIdError)}
                />
                {accountIdError && (
                    <FormHelperText>{validationError}</FormHelperText>
                )}
            </FormControl>

            <FormControl
                className="mb-3"
                style={{ width: "100%" }}
                error={Boolean(accessTokenError)}
            >
                <TextField
                    name="accessToken"
                    inputProps={{
                        "data-cy": "create-destination-pinterest-token",
                    }}
                    label={accessTokenLabel}
                    variant="outlined"
                    onChange={onChange}
                    value={formData.accessToken}
                    placeholder={accessTokenLabel}
                    error={Boolean(accessTokenError)}
                />
                {accessTokenError && (
                    <FormHelperText>{validationError}</FormHelperText>
                )}
            </FormControl>

            <FormControl className="mb-3" style={{ width: "100%" }}>
                <TextField
                    name="pinterestTagId"
                    inputProps={{
                        "data-cy": "create-destination-pinterest-tag",
                    }}
                    label={tagIdLabel}
                    variant="outlined"
                    onChange={onChange}
                    value={formData.pinterestTagId}
                    placeholder={tagIdLabel}
                />
            </FormControl>
        </div>
    );
};

export default PinterestCapiFields;
